import HttpUtil from "../HttpUtil"
import utils from "@/assets/js/Utils"

import { PagedResponse } from "../Model/ResponseModel";
import Urls from "../Urls"
const GetAssets = (search: any, page: number, pageSize: number): Promise<PagedResponse<any>> => {
    const array: string[] = ["assetName", "serial","address","assetTypeName"]
    const req = utils.GetPageReq(page, pageSize, search, array);
    req.conditions.push({
        field: "delete",
        value: "0",
        conditionType:0,
        andCondition:true
    });
    return HttpUtil.XCHttpPost<any, PagedResponse<any>>(Urls.GetAssets, req, true, false);
}

const GetOrders = (search: any, page: number, pageSize: number,serial?:string): Promise<PagedResponse<any>> => {
    const array: string[] = ["workOrderTypeName", "address","assetName","assetTypeName","sid","assetDesc"]
    const req = utils.GetPageReq(page, pageSize, search, array);
    req.conditions.push({
        field: "delete",
        value: "0",
        conditionType:0,
        andCondition:true
    });
    let noloading=false;
    if(serial){
        req.conditions.push({
            field: "serial",
            value: serial,
            conditionType:0,
            andCondition:true
        });
        noloading=true;
    }
    return HttpUtil.XCHttpPost<any, PagedResponse<any>>(Urls.GetOrders, req, true, noloading);
}
const GetOrderTypes = (search: any, page: number, pageSize: number): Promise<PagedResponse<any>> => {
    const array: string[] = ["name","lightOfflineAsyc"]
    const req = utils.GetPageReq(page, pageSize, search, array);
    return HttpUtil.XCHttpPost<any, PagedResponse<any>>(Urls.GetOrderTypes, req, true, false);
}
const GetLightInspections = (search: any, page: number, pageSize: number): Promise<PagedResponse<any>> => {
    const array: string[] = ["name"]
    const req = utils.GetPageReq(page, pageSize, search, array);
    if(!req.orderByConditions){
        req.orderByConditions=[];
    }
    req.orderByConditions.push({
        field:"createTime",
        asc:false
    });
    return HttpUtil.XCHttpPost<any, PagedResponse<any>>(Urls.GetLightInspections, req, true, false);
}
const GetOrderInspections = (search: any, page: number, pageSize: number): Promise<PagedResponse<any>> => {
    const array: string[] = ["name"]
    const req = utils.GetPageReq(page, pageSize, search, array);
    if(!req.orderByConditions){
        req.orderByConditions=[];
    }
    req.orderByConditions.push({
        field:"createTime",
        asc:false
    });
    return HttpUtil.XCHttpPost<any, PagedResponse<any>>(Urls.GetOrderInspections, req, true, false);
}
export default {
    GetAssets:GetAssets,GetOrderTypes:GetOrderTypes,GetOrders:GetOrders,GetLightInspections:GetLightInspections,GetOrderInspections:GetOrderInspections
}